import { render, staticRenderFns } from "./testtemp.vue?vue&type=template&id=2ebda31e&scoped=true"
import script from "./testtemp.vue?vue&type=script&lang=js"
export * from "./testtemp.vue?vue&type=script&lang=js"
import style0 from "./testtemp.vue?vue&type=style&index=0&id=2ebda31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebda31e",
  null
  
)

export default component.exports